import React from 'react'
import * as NavActions from 'x/utils/navigation'
import _ from 'lodash'
import p from 'x/config/platform-specific'
import * as util from 'x/utils/util'
import { ISelectedStoreMap, IProfileMap, IXScreenProps } from 'x/index'
import XIcon from 'xui/components/XIcon'
import { APP_CONFIG } from 'x/config/mode'
import { Linking, Dimensions } from 'react-native'
import CONS from 'x/config/constants'
import dayjs from 'dayjs'
import { Map, List } from 'immutable'
// import codePush from 'react-native-code-push'

interface IBaseSellerStoresViewProps extends IXScreenProps {
  selectedStore: ISelectedStoreMap
  profile: IProfileMap
  fetchUserProfile: any
  dispatch?: (param?: any) => void
  appendPendingStore: any
  myPendingStores: any
  applyInviteCode: any
  fetchStores: any
  stores: List<any>
}

interface IBaseSellerStoresViewState {
  txtInviteCode: string
  isVisibleModal: boolean
  foundSellerStore: any

  submitting: boolean
  referer_id: string | null
  isRefreshing: boolean
}

export default abstract class BaseSellerStoresView extends React.Component<IBaseSellerStoresViewProps, IBaseSellerStoresViewState> {
  // abstract async handleSubmitForm(response: any): Promise<void>
  // abstract didMountCheckPermissionForPhone?: () => void
  // validationSchema: Yup.ObjectSchema<any>
  // imgManagerIDRef: React.RefObject<any>
  // MENU_ABOUT_ME: IMenu[]

  // MENU_ABOUT_XSELLY: IMenu[]

  _inProcess: boolean
  _lastfailedApplyCodeDate?: any
  _failedApplyCodeCount?: number
  _failedMemoCodes?: Map<string, string>
  _bannedUntilDate?: any
  _failedCountBanAt?: number
  _banAmountMinutes?: number
  mode: string

  SCREEN_WIDTH: number

  constructor(props) {
    super(props)
    this.state = {
      txtInviteCode: '',
      foundSellerStore: null,
      isVisibleModal: false,
      submitting: false,
      referer_id: null,
      isRefreshing: false,
    }
    this._inProcess = false
    this._lastfailedApplyCodeDate = null
    this._failedApplyCodeCount = 0
    this._failedMemoCodes = Map({})
    this._bannedUntilDate = null
    this._failedCountBanAt = 8
    this._banAmountMinutes = 30
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.mode = CONS.STORES_MODE_MY_VIEW
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.SCREEN_WIDTH = Dimensions.get('screen').width
  }

  async componentDidMount() {}

  componentWillUnmount(): void {}

  _setStateDelayToCloseModal = async () => {
    await util.setStatePromise(this, {
      isVisibleModal: false,
      isVisibleCamera: false,
      txtInviteCode: '',
      decodedQRSrc: null,
      decoding: false,
      submitting: false,
      foundSellerStore: null,
    })
    await util.delay(1500)
  }

  _handleOnPickQrCode = async () => {
    //
  }

  _onRequestCloseModal = () => {
    this.setState({ isVisibleModal: false })
  }

  _onChangeInviteCode = (newText: string) => {
    if (this._inProcess) {
      return
    }
    this._inProcess = true
    this.setState(
      {
        txtInviteCode: newText ? newText.toString() : '',
      },
      () => {
        this._inProcess = false
      }
    )
  }

  _onPressManualSubmitInviteCode = async () => {
    let txtInviteCode = _.has(this.state, 'txtInviteCode') ? this.state.txtInviteCode : null
    txtInviteCode = txtInviteCode.toUpperCase()
    await util.setStatePromise(this, { txtInviteCode })
    this._handleSubmitInvitationCode(txtInviteCode)
  }

  _handleOnEmptySocialContact = async (code: string): Promise<void> => {
    const isUserConfirm = await p.op.isUserConfirm(
      'กรุณาระบุช่องทางติดต่อของฉัน',
      'เพื่อให้ผู้ขายส่งติดต่อฉันได้ กรุณาระบุไอดีไลน์ (LINE ID) หรือเฟสบุ๊ค (Facebook ID) ใน "ข้อมูลส่วนตัวของฉัน" '
    )
    if (isUserConfirm) {
      this._navToProfileViewToFillSocialContact(code)
    }
  }

  _navToProfileViewToFillSocialContact = (code: string) => {
    // เอาไว้ block ui ไม่ให้กดดำเนินการอะไรในระหว่าง nav ไปเฉยๆ
    this._inProcess = true
    setTimeout(() => {
      this._inProcess = false
    }, 500)
    const { navigation } = this.props
    const callbackAfterSaveSuccess = (res) => res && this._callbackAfterProfileSaveSuccess(code, res)
    p.op.showToast('FIX NAV', 'warning')
    // const navAction = NavActions.navToProfileRequiredContact(callbackAfterSaveSuccess)
    // navigation.dispatch(navAction)
  }

  _callbackAfterProfileSaveSuccess = (code, res): void => {
    if (_.has(res, 'profile') && _.isObject(res.profile)) {
      const { fb_id = null, line_id = null } = res.profile
      if ((_.isNull(fb_id) || fb_id === '') && (_.isNull(line_id) || line_id === '')) {
        // ถ้าไม่มีทั้ง facebook_id และ line_id
        this._handleOnEmptySocialContact(code)
      } else {
        // ถ้ามี social contact แล้ว
        this._handleSubmitInvitationCode(code)
      }
    }
  }

  _onRefresh = async () => {
    // this.isPullRefreshing = true
    if (this.state && this.state.isRefreshing) {
      return
    }
    await util.setStatePromise(this, { isRefreshing: true })
    await new Promise((resolveReq) => {
      this.props.fetchStores(this.getFetchBody(resolveReq))
    })
  }

  getFetchBody = (apiCallback?: (res: any) => void) => {
    if (_.isFunction(apiCallback)) {
      return {
        successCallback: async (res) => {
          await this._afterSuccessFetchStores()
          apiCallback(res)
        },
        failedCallback: async () => {
          await this._afterFailedFetchStores()
          apiCallback(null)
        },
      }
    }
    return {
      successCallback: this._afterSuccessFetchStores,
      failedCallback: this._afterFailedFetchStores,
    }
  }

  _afterSuccessFetchStores = async () => {
    await util.setStatePromise(this, { isRefreshing: false })
  }

  _afterFailedFetchStores = async () => {
    await util.setStatePromise(this, { isRefreshing: false })
  }

  _handleSubmitInvitationCode = async (code: string, isUserConfirmToJoin?: boolean) => {
    console.log('_handleSubmitInvitationCode code => ', code, isUserConfirmToJoin)
    const { submitting, referer_id = null } = this.state
    if (this._inProcess || submitting) {
      return
    }
    this._inProcess = true

    const { profile = null } = this.props
    if (!Map.isMap(profile)) {
      this._inProcess = false
      throw new Error('No Profile prop')
    }
    const fb_id = profile.get('fb_id')
    const line_id = profile.get('line_id')
    if (!fb_id && !line_id) {
      await this._handleOnEmptySocialContact(code)
      // await this._setStateDelayToCloseModal()
      this._inProcess = false
      return
    }

    if (!code || code.length < 5) {
      await this._setStateDelayToCloseModal()
      p.op.alert('รหัสเข้าร่วมร้านค้าไม่ถูกต้อง', 'กรุณากรอกรหัส 5 หลักที่ได้จากร้านค้า เพื่อสมัครสมาชิกร้านค้า')
      this._inProcess = false
      return
    }

    if (this._failedMemoCodes.has(code)) {
      // @ts-ignore
      const { title, msg } = this._failedMemoCodes.get(code)
      p.op.alert(title, msg)
      await this._setStateDelayToCloseModal()
      this._inProcess = false
      return
    }

    let foundExistPendingStore = this.props.myPendingStores.find((store) => store.get('code') === code)
    if (Map.isMap(foundExistPendingStore)) {
      const storeName = foundExistPendingStore.get('name')
      await this._setStateDelayToCloseModal()
      // Refresh ข้อมูลให้เป็นปัจจุบัน
      await this._onRefresh()
      await util.delay(500) // for state/props update
      foundExistPendingStore = this.props.myPendingStores.find((store) => store.get('code') === code)
      // เอาข้อมูลที่อัพเดทแล้ว มาเช็คอีกครั้ง เพื่ออำนวยความสะดวก user ว่าตกลง "ฉัน อยู่ในร้านนี้รึยัง? หรือยังต้องรอร้านขายส่ง?"
      if (Map.isMap(foundExistPendingStore)) {
        p.op.alert('คุณได้สมัครเข้าร้านนี้ไปแล้ว', `กรุณาติดต่อร้าน "${storeName}" เพื่ออนุมัติการสมัครเป็นสมาชิก`)
      } else {
        p.op.showToast(`คุณเป็นสมาชิกร้าน "${storeName}" แล้ว`, 'success')
      }
      this._inProcess = false
      return
    }

    if (dayjs.isDayjs(this._bannedUntilDate)) {
      const now = dayjs()
      if (now.isSame(this._bannedUntilDate) || now.isBefore(this._bannedUntilDate)) {
        const txtWillUnbanIn = this._bannedUntilDate.fromNow(true)
        await this._setStateDelayToCloseModal()
        p.op.alert(
          'รหัสผ่านไม่ถูกต้องเป็นจำนวนมาก',
          `กรุณากรอกใช้รหัสที่ใช้สมัครเป็นตัวแทนร้าน 5 หลักที่ถูกต้องในอีก ${txtWillUnbanIn} ข้างหน้า เนื่องจากระบบตรวจพบการระบุรหัสผ่านที่ไม่ถูกต้องซ้ำกันอย่างต่อเนื่องจึงหยุดรับรหัสผ่านชั่วคราว`
        )
        this._inProcess = false
        return
      }
      this._bannedUntilDate = null
    }

    // เปิด Modal เพื่อจะแสดงผลการขอเข้าร่วมร้าน
    // await setStatePromise(this, { isVisibleModal: true, submitting: true, foundSellerStore: null })
    await util.setStatePromise(this, { submitting: true, isVisibleModal: false })
    // await new Promise(delayBefore => setTimeout(delayBefore, 200))
    await util.delay(200)

    const { applyInviteCode } = this.props
    if (!_.isFunction(applyInviteCode)) {
      // should be impossible
      this._inProcess = false
      return
    }

    // let body = { invite_code: code }
    const body: { [key: string]: any } = {}
    const fbShortLink = 'https://xselly.page.link'
    if (code.indexOf(fbShortLink) > -1) {
      body.invite_link = code
    } else {
      body.invite_code = code.toUpperCase()
    }
    if (isUserConfirmToJoin) {
      body.is_confirm = true
    }
    if (referer_id) {
      body.r = referer_id
    }

    await new Promise((isFetched) => {
      applyInviteCode({
        body,
        successCallback: async (res) => {
          await this._afterSuccessApplyInviteCode(res)
          // @ts-ignore
          isFetched()
        },
        failedCallback: async (err) => {
          await this._afterFailedApplyInviteCode(err)
          // @ts-ignore
          isFetched()
        },
      })
      // setTimeout(isFetched, 12000) // manual timeout 12 sec
    })

    const newSubmittedState = { submitting: false }
    if (isUserConfirmToJoin) {
      // @ts-ignore
      newSubmittedState.txtInviteCode = ''
    }
    await util.setStatePromise(this, newSubmittedState)
    await util.delay(200)
    this._inProcess = false
  }

  _afterFailedApplyInviteCode = async (err) => {
    // log('_afterFailedApplyInviteCode err => ', err)
    if (err.error && err.error.error_code) {
      const { error_code } = err.error
      const errCodeArr = error_code.split('_')
      const lastErrCode = _.isArray(errCodeArr) ? errCodeArr[errCodeArr.length - 1] : null
      if (lastErrCode && parseInt(lastErrCode) >= 59 && parseInt(lastErrCode) <= 62) {
        const errObj = util.getErrMessageObj(err)
        // @ts-ignore
        this._failedMemoCodes = this._failedMemoCodes.set(this.state.txtInviteCode, errObj)
        // log('_afterFailedApplyInviteCode:: this.state.txtInviteCode => ', this.state.txtInviteCode)
        // log('_afterFailedApplyInviteCode:: new this._failedMemoCodes.toJS() => ', this._failedMemoCodes.toJS())
      }
    }

    // p.op.showToast('การสมัครเป็นตัวแทนร้านล้มเหลว')
    const now = dayjs()
    // log('error now => ', now)
    if (!dayjs.isDayjs(this._lastfailedApplyCodeDate)) {
      this._lastfailedApplyCodeDate = now
    } else {
      const diffSeconds = Math.abs(now.diff(this._lastfailedApplyCodeDate, 'seconds'))
      if (diffSeconds <= 60) {
        this._failedApplyCodeCount += 1
        if (this._failedApplyCodeCount >= this._failedCountBanAt) {
          // ควรจะถูกแบน
          this._bannedUntilDate = dayjs().add(this._banAmountMinutes, 'minutes')
        }
      } else {
        this._failedApplyCodeCount = 0
        this._bannedUntilDate = null
      }
      // log('error diffSeconds => ', diffSeconds)
    }

    await this._setStateDelayToCloseModal()
  }

  _afterSuccessApplyInviteCode = async (res) => {
    // log('_afterSuccessApplyInviteCode res => ', res)
    if (_.has(res, 'status') && res.status === 'ok') {
      const { txtInviteCode, foundSellerStore } = this.state
      // log('_afterSuccessApplyInviteCode foundSellerStore => ', foundSellerStore)
      await new Promise((resolveAppend) => {
        this.props.appendPendingStore({
          ...foundSellerStore,
          code: txtInviteCode,
        })
        setTimeout(resolveAppend, 200)
      })
      await util.setStatePromise(this, {
        isVisibleModal: false,
        txtInviteCode: '',
        isVisibleCamera: false,
        foundSellerStore: null,
      })
      p.op.showToast('การสมัครเป็นสมาชิกสำเร็จ', 'success')
    } else if (_.has(res, 'store') && _.isObject(res.store)) {
      const { store, old_ug, new_ug } = res
      await util.setStatePromise(this, {
        isVisibleModal: true,
        isVisibleCamera: false,
        foundSellerStore: store,
        foundOldUg: old_ug,
        foundNewUg: new_ug,
      })
    }

    // await new Promise(delayForState => setTimeout(delayForState, 1200))
  }

  _onPressInsertInviteWithScanQRCode = async () => {
    if (this._inProcess) {
      return
    }
    this._inProcess = true
    await util.setStatePromise(this, {
      isVisibleModal: true,
      isVisibleCamera: true,
      txtInviteCode: '',
      foundSellerStore: null,
      submitting: false,
      decodedQRSrc: null,
      decoding: false,
    })
    await util.delay(500)
    this._inProcess = false
  }

  _getStores = () => {
    const storeList = this.props.stores || List([])
    const myPendingStores = this.props.myPendingStores || List([])
    const stores = storeList.concat(myPendingStores)
    return stores
  }
}
